module.exports = __webpack_public_path__ + "img/skype.0d069430.png";